/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class CalendarSyncIcsService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Calendrier d'un personnel (ICS)
     * Flux `text/calendar` a abonner dans un agenda (Google, Outlook, iOS). Le `hash` identifie le personnel ; couvre 3 mois avant et 3 mois apres la date du jour. Techniciens : leurs interventions ; commerciaux : leurs rendez-vous. 404 pour les autres profils.
     * @param hash
     * @returns string
     * @throws ApiError
     */
    public calendarSyncIcsGenerate(
        hash: string,
    ): CancelablePromise<string> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/ics/{hash}',
            path: {
                'hash': hash,
            },
        });
    }
}
